import React from 'react';
import { Section } from './ui/Section';
import { Button } from './ui/Button';
import { Download, BookOpenIcon, HeartIcon, MessageCircleIcon, CheckCircle2 } from 'lucide-react';
export function ResourcesSection() {
  const ebooks = [{
    icon: <HeartIcon className="w-6 h-6 text-brand-primary" data-id="element-223" />,
    title: 'Harta Rănilor Emoționale',
    subtitle: 'Mindset Booster cu Legile Universale',
    description: 'Cum să recunoști cele 5 tipare care îți influențează emoțiile și relațiile.'
  }, {
    icon: <BookOpenIcon className="w-6 h-6 text-brand-accent" data-id="element-224" />,
    title: 'Ce sunt emoțiile?',
    subtitle: 'Ghid de înțelegere emoțională',
    description: 'Emoțiile sunt trăiri complexe care au componente mentale, fizice și comportamentale — sunt limbajul corpului, ele ne arată ce programe rulează în fundal.'
  }, {
    icon: <MessageCircleIcon className="w-6 h-6 text-brand-secondary" data-id="element-225" />,
    title: 'Ghid de Comunicare Congruentă',
    subtitle: 'Pentru manageri, experți și profesioniști',
    description: 'Pentru cei care știu multe, dar nu reușesc să comunice clar & congruent. Te ajut să transformi emoțiile și fricile din spatele comunicării.'
  }];
  return <Section id="resurse" background="white" data-id="element-226">
      <div className="text-center mb-10" data-id="element-227">
        <span className="inline-block px-4 py-1.5 mb-4 text-xs font-bold tracking-wider text-brand-primary uppercase bg-brand-primary/10 rounded-full border border-brand-primary/20" data-id="element-228">
          Resurse Gratuite
        </span>
        <h2 className="text-3xl md:text-4xl font-bold text-brand-text mb-4" data-id="element-229">
          3 E-book-uri CADOU pentru tine
        </h2>
        <p className="text-lg text-gray-700 max-w-2xl mx-auto" data-id="element-230">
          Primești acces gratuit la 3 ghiduri practice create de mine, ca să
          începi să lucrezi cu tine chiar de acum.
        </p>
      </div>

      <div className="max-w-3xl mx-auto bg-white rounded-2xl border-2 border-brand-primary/20 shadow-lg p-8 md:p-10" data-id="element-231">
        <h3 className="text-xl md:text-2xl font-bold text-brand-text mb-2 text-center" data-id="element-232">
          Ce primești în cele 3 ghiduri:
        </h3>
        <p className="text-gray-600 text-center mb-8 text-[15px]" data-id="element-233">
          Autor: Elena Daniela Sămărtinean — Psiholog Clinician & Psihoterapeut
          Integrativ
        </p>

        <div className="space-y-6 mb-10" data-id="element-234">
          {ebooks.map((ebook, index) => <div key={index} className="flex items-start gap-4 p-4 rounded-xl bg-brand-bg/60" data-id="element-235">
              <div className="flex-shrink-0 mt-0.5 p-2.5 bg-white rounded-lg shadow-sm" data-id="element-236">
                {ebook.icon}
              </div>
              <div data-id="element-237">
                <div className="flex items-center gap-2 mb-1" data-id="element-238">
                  <h4 className="text-lg font-bold text-brand-text" data-id="element-239">
                    {ebook.title}
                  </h4>
                </div>
                <p className="text-sm font-medium text-brand-primary mb-1.5" data-id="element-240">
                  {ebook.subtitle}
                </p>
                <p className="text-gray-700 text-[15px] leading-relaxed" data-id="element-241">
                  {ebook.description}
                </p>
              </div>
            </div>)}
        </div>

        <div className="text-center" data-id="element-242">
          <a href="https://drive.google.com/drive/folders/11ZxZCHf5GnWI5fZ7Zw6EKIx8bJ2hd7kh?usp=sharing" data-id="element-243">
            <Button variant="primary" size="lg" className="flex items-center justify-center mx-auto" data-id="element-244">
              <Download className="mr-2 w-5 h-5" data-id="element-245" />
              Descarcă cele 3 E-book-uri Gratuit
            </Button>
          </a>
        </div>
      </div>
    </Section>;
}